export const REFRESH_TRANSACTIONS_EVENT = 'refresTransactions';
export const SESSION_EXPIRED_EVENT = 'sessionExpired';
